module.exports = __webpack_public_path__ + "static/carou3-62caf7ea2ed2e3503b4b29e1b2862719.jpg";